//copyright itestra 2016
import {
    Component,
    OnInit,
    AfterViewInit,
    EventEmitter,
    Output,
    ChangeDetectionStrategy,
    inject,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable, startWith, withLatestFrom } from "rxjs";
import { Store } from "@ngrx/store";
import * as moment from "moment";

import { RootState } from "../store/root";
import { stateBuilder } from "../store/utils";
import { ConsultationProcess, Offer, Division } from "../data/model";
import { UtilsComponent } from "../components/utils.component";
import { PersistenceService } from "../store/model/persistence.service";
import { zbdGlobals } from "../../globals";
import { LoggerService } from "../services/logger.service";

@Component({
    selector: "zbd-admin",
    templateUrl: "admin.component.html",
    styleUrls: ["admin.component.css"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminComponent extends UtilsComponent {
    state$: Observable<LocalState>;

    getKeys = Object.keys;
    JSON = JSON;
    zbdGlobals = zbdGlobals;
    buildVersion = version.BUILD_VERSION;

    valueClassSelector = (value: any) => ({
        "value-number": typeof value === "number",
        "value-string": typeof value === "string",
        "value-boolean": typeof value === "boolean",
        "value-null": value == null,
    });

    private logger = inject(LoggerService);

    constructor(
        private route: ActivatedRoute,
        private persistence: PersistenceService,
        store: Store<RootState>,
    ) {
        super();

        this.state$ = LocalState.create(store);

        const stateParams = this.route.params.pipe(
            withLatestFrom(this.state$.pipe(startWith(undefined))),
        );
        this.register(
            stateParams.subscribe(([params, state]) => {
                const cpId: number = parseInt(params["protocolID"]);
                if (state && state.cp && state.cp.Id == cpId) {
                    return;
                }
                this.logger.log(
                    "Loading consultation process with ID %d.",
                    cpId,
                );
                this.persistence.loadConsultationProcess(cpId);
            }),
        );
    }

    getTitle(cp: ConsultationProcess, offer: Offer, div: Division): string {
        const offerTitle = offer.ExternalId
            ? `Vorgang ${offer.ExternalId} (${cp.Application}, ${div.ChangeType})`
            : "Vorgang ohne Tarifrechner";
        return `${offerTitle} - ${div.Label}`;
    }

    getVars(metadata: any) {
        const vars = [];
        AdminComponent.flatten("", JSON.parse(metadata), vars);
        return vars;
    }

    private static flatten(prefix, item, vars) {
        if (typeof item === "object") {
            if (item == null) {
                return "";
            } else if (item.length) {
                item.forEach((elem, index) => {
                    AdminComponent.flatten(`${prefix}[${index}]`, elem, vars);
                });
            } else {
                for (const key in item) {
                    const newPrefix = prefix + (prefix ? "." : "") + key;
                    AdminComponent.flatten(newPrefix, item[key], vars);
                }
            }
        } else {
            vars.push({
                key: prefix,
                value: item,
            });
        }
    }
}

class LocalState {
    cp: ConsultationProcess;

    static create(store: Store<RootState>): Observable<LocalState> {
        return stateBuilder(store, new LocalState()).apply(
            "cp",
            (s) => s.model.ConsultationProcess,
        ).state$;
    }
}
